import React from "react";
import { Modal } from "react-bootstrap";

import { CloseButton, OnlineLink } from "components";

import styles from "../modal.module.scss";

const BillingPreviewModal = ({ details, show, onHide }) => {
	const tsLink = details.application_id
		? `/tid-request-equipment-queue/unassigned/${details.application_id}/terminal-solutions/${details.terminal_id}`
		: `/merchant/list/info/${details?.merchant_id}/terminal-solutions/${details.terminal_id}/edit`;

	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			centered
			className={styles.centeredLabelsModal}
		>
			<Modal.Header className="pb-0">
				<Modal.Title as="h6" className="text-center">
					ACH Payment Details
				</Modal.Title>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body className="d-flex flex-column pt-0">
				<div className="d-flex mt-3">
					<div className={styles.label}>MID:</div>
					<div className={styles.value}>
						<OnlineLink
							to={`/merchant/list/info/${details?.merchant_id}/general`}
							target="_blank"
						>
							{details?.merchant?.mid}
						</OnlineLink>
					</div>
				</div>
				<div className="d-flex mt-3">
					<div className={styles.label}>Merchant Name:</div>
					<div className={styles.value}>
						{details?.merchant?.dba_name}
					</div>
				</div>
				<div className="d-flex mt-3">
					<div className={styles.label}>Terminal Solution #:</div>
					<div className={styles.value}>
						<OnlineLink to={tsLink} target="_blank">
							TS - {details.terminal_number}
						</OnlineLink>
					</div>
				</div>
				<div className="d-flex mt-3">
					<div className={styles.label}>Amount To Be Billed:</div>
					<div className={styles.value}>
						{details.amount_to_be_billed}
					</div>
				</div>
				<div className="d-flex mt-3">
					<div className={styles.label}>Routing Number (ABA):</div>
					<div className={styles.value}>
						{details?.merchant?.routing_number}
					</div>
				</div>
				<div className="d-flex mt-3">
					<div className={styles.label}>Account Number (DDA):</div>
					<div className={styles.value}>
						{details?.merchant?.account_number}
					</div>
				</div>
				<div className="d-flex mt-3">
					<div className={styles.label}>Bank Account Name:</div>
					<div className={styles.value}>
						{details?.merchant?.bank_account_name}
					</div>
				</div>
				<div className="d-flex mt-3">
					<div className={styles.label}>Bank:</div>
					<div className={styles.value}>
						{details?.merchant?.bank}
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default BillingPreviewModal;

